import { render, staticRenderFns } from "./LeaveReport.vue?vue&type=template&id=08b4e978"
import script from "./LeaveReport.vue?vue&type=script&lang=js"
export * from "./LeaveReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports